// extracted by mini-css-extract-plugin
export var cell = "_77-4";
export var headerCell = "_77-2";
export var rowHeader = "_77-3";
export var table = "_77-1";
export var tableContainer = "_77-0";